<template>
    <div :class="[$style['mds-stepper'], classObject, sizeClass]" :data-mds-version="version">
        <div :class="$style['mds-stepper__list']">
            <slot> </slot>
        </div>
        <div :class="$style['mds-stepper__active-step-summary']" v-if="responsive">
            <!-- label for responsive variation -->
            <span :class="$style['mds-stepper__active-step-label']">
                <slot name="summary-label"></slot>
            </span>
            <!-- label for responsive variation -->
            <span :class="$style['mds-stepper__active-step-microcopy']">
                <slot name="summary-microcopy"></slot>
            </span>
        </div>
    </div>
</template>

<script>
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'MdsStepper',
        props: {
            disableAnimation: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, step progression will not be visually animated.',
                },
            },
            nonLinear: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, disables blue line tracking.',
                },
            },
            onDark: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, changes component to on-dark styling.',
                },
            },
            responsive: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, renders the responsive variation of the stepper.',
                },
            },
            size: {
                type: String,
                default: 'medium',
                validator(value) {
                    return ['small', 'medium', 'large'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `small`, `medium`, `large`.',
                    description: 'Sets the size of the stepper.',
                },
            },
        },
        data() {
            return {
                version: `${name}-${version}`,
            };
        },
        computed: {
            classObject() {
                const obj = {};
                obj[this.$style['mds-stepper--responsive']] = this.responsive;
                obj[this.$style['mds-stepper--no-animation']] = this.disableAnimation;
                obj[this.$style['mds-component--on-dark']] = this.onDark;
                obj[this.$style['mds-stepper--linear']] = !this.nonLinear;
                obj[this.$style['mds-stepper--clicked']] = this.clicked;

                return obj;
            },
            sizeClass() {
                return this.$style[`mds-stepper--${this.size}`];
            },
        },
    };
</script>

<style lang="scss" module>
    @import './stepper.scss';
</style>
